"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 25.2",
    width: "24.5",
    height: "25.2"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.5",
    y: "20.8",
    width: "8",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5,21.8h-3c-0.2,0-0.3-0.1-0.4-0.2C0,21.4,0,21.2,0,21.1l1.6-3.3l0.9,0.4l-1.2,2.6h2.2V21.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M7.6,16.8H4.9c-0.3,0-0.5-0.2-0.5-0.5v-1.8c0-0.3,0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5v1.8 C8.1,16.6,7.9,16.8,7.6,16.8z M5.4,15.8h1.7V15H5.4V15.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M20.2,16.8h-2.7c-0.3,0-0.5-0.2-0.5-0.5v-1.8c0-0.3,0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5v1.8 C20.7,16.6,20.5,16.8,20.2,16.8z M18,15.8h1.7V15H18V15.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M21.1,15H4c-0.3,0-0.5-0.2-0.5-0.5v-3.6c0-0.1,0.1-0.3,0.1-0.4l1.8-1.8c0.1-0.1,0.2-0.1,0.4-0.1h13.5 c0.1,0,0.3,0.1,0.4,0.1l1.8,1.8c0.1,0.1,0.1,0.2,0.1,0.4v3.6C21.6,14.8,21.4,15,21.1,15z M4.5,14h16.1v-2.9l-1.5-1.5H6l-1.5,1.5 V14z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M19.3,9.6H5.8c-0.2,0-0.3-0.1-0.4-0.2s-0.1-0.3,0-0.5l1.8-4.5c0.1-0.2,0.3-0.3,0.5-0.3h9.9 c0.2,0,0.4,0.1,0.5,0.3l1.8,4.5c0.1,0.2,0,0.3,0,0.5S19.5,9.6,19.3,9.6z M6.5,8.6h12l-1.4-3.5H7.9L6.5,8.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M8,13.2H4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H8c0.3,0,0.5,0.2,0.5,0.5S8.3,13.2,8,13.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M21.1,13.2h-4.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.1c0.3,0,0.5,0.2,0.5,0.5S21.4,13.2,21.1,13.2z "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M4,19.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M7.2,19.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M15.7,19.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,21.8h-2.5v-1h1.6l-1.7-2.4l0.8-0.6l2.2,3.2c0.1,0.2,0.1,0.4,0,0.5C24.4,21.7,24.2,21.8,24,21.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M14.7,4.7"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.1,3.4l-0.9-0.5l1.6-2.7c0.2-0.3,0.7-0.3,0.9,0l1.5,2.6l-0.9,0.5l-1.1-1.8L11.1,3.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M10.7,3.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M9.8,4.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M6.1,25.2c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.4,0-0.8,0.4-1c0.2-0.1,0.8-0.5,0.9-0.9c0.1-0.4-0.3-0.8-0.6-1.1 c-0.9-0.8-1.2-1.6-1-2.4c0.3-1.1,1.7-1.5,1.8-1.6c0.4-0.1,0.8,0.1,0.9,0.5c0.1,0.4-0.1,0.8-0.5,0.9c-0.3,0.1-0.7,0.3-0.7,0.5 c0,0.1,0.1,0.4,0.6,0.9c0.8,0.8,1.2,1.6,1,2.4c-0.2,1.3-1.6,2-1.8,2C6.3,25.2,6.2,25.2,6.1,25.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M18.6,25.2c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.4,0-0.8,0.4-1c0.2-0.1,0.8-0.5,0.9-0.9c0.1-0.4-0.3-0.8-0.6-1.1 c-0.9-0.8-1.2-1.6-1-2.4c0.3-1.1,1.7-1.5,1.8-1.6c0.4-0.1,0.8,0.1,0.9,0.5c0.1,0.4-0.1,0.8-0.5,0.9c-0.3,0.1-0.7,0.3-0.7,0.5 c0,0.1,0.1,0.4,0.6,0.9c0.8,0.8,1.2,1.6,1,2.4c-0.2,1.3-1.6,2-1.8,2C18.8,25.2,18.7,25.2,18.6,25.2z"
  }));
};

exports["default"] = _default;